import React from "react";
import Grid from "@mui/material/Grid";
export default function DetailTemplateFinancial(props: any) {
    return (
        <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }}
            className="suppliersListDetailContent"
            style={{ alignSelf: 'center' }}>
            <span className="financialListDetailTitle" >
                {props.title}
            </span>
            <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }} style={{ alignSelf: 'center', paddingTop: '20px',lineHeight:"35px" }}>
                {props.data?.length > 0 ?
                    props.data?.map((item: any, index: number) => (
                        <Grid xs={6}
                            md={3}
                            sm={6}
                            // borderLeft={{
                            //     lg: `${++index <= props.data?.length - 1 ? "1px solid #c1c7cb" : ""}`,
                            //     md: `${++index <= props.data?.length - 1 ? "1px solid #c1c7cb" : ""}`
                            // }}
                            borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                            paddingX={".5rem"}
                            paddingY={{
                                xs: "1rem",
                                sm: "1rem",
                                md: "1rem",
                                lg: "0",
                                xl: "0",
                            }}
                        >
                            <ul style={{ display: ' table-cell' }}>
                                <li >
                                    <span >{item.installmentDuration} ماهه با فاصله قسط {item.stepSpaceByMonth} ماه</span>
                                </li>
                            </ul>
                        </Grid>
                    ))
                    : ""
                }


            </Grid>
        </Grid>
    )
}